import React from 'react'

const PersonalisedForYou = () => {
    return (
        <div className='py-1 flex rounded-lg' style={{background: 'linear-gradient(268.49deg, #3779BB 0%, #87BCF1 100%)'}}>
            <img src="https://assets.learntube.ai/files/premium_1.svg?updatedAt=1689229408174" width={16} height={16} alt="" className='ml-2'/>
            <p className='text-[11px] mx-2'>Personalised For You</p>
        </div>
    )
}

export default PersonalisedForYou